import React, { useEffect, useState } from "react";
import closeIcon from "../../../../src/assests/img/close-icon.svg";
import "../../../Components/Admin/connections/Connection.css";
import { NO_LOGS_FOUND } from "./ARSConstants";
import { getLogDetail } from "./ARSServices/ARSServices";
import Button from "Components/DesignSystem/Button/Button";
import { Refresh } from "Components/DesignSystem/Iconography/Icons";

type ARSLogsProps = {
  id: string;
  model_id: string;
  setShowLogs: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedLog: React.Dispatch<React.SetStateAction<ArsLogsResponse | null>>
}

const ARSLogs = ({ setShowLogs, id, model_id, setSelectedLog }: ARSLogsProps) => {

  const [logs, setLogs] = useState<string>('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getArsLog();
  }, [id]);

  const getArsLog = async () => {
    try {
      setLoading(true);
      const response = await getLogDetail(id);
      if (response?.done) {
        const arsLogs = response?.data?.logs ?? '';
        setLogs(arsLogs);
      }
    } catch (error) {
      console.error("getARSLog ~ error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="ars-logs-view" className="form-header tw-z-50">
      <div>
        <div className="tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-3 tw-gap-2">
          <span className="mb-0 connection-text align-self-center fs-5">
            Logs
            {/* DS subtle Button + Refresh (currentColor). The legacy button pinned
                color #091caa inline — navy, near-invisible in dark — over a
                btn-light whose chrome the other inline styles had already
                neutralised. Same swap as the Rules Queue title refresh. */}
            <Button
              variant="subtle"
              size="sm"
              aria-label="Refresh"
              data-testid="ars-arslogs-button-1"
              onClick={() => getArsLog()}
            >
              <Refresh aria-hidden="true" />
            </Button>
          </span>
          <button data-testid="ars-arslogs-button-2" className="tw-border-none tw-shadow-none" onClick={() => { setShowLogs(false); setSelectedLog(null) }}>
            <img src={closeIcon} alt="Close icon" />
          </button>
        </div>
        <div className="tw-px-4 tw-pb-2">
          <label className="tw-text-sm tw-text-[#091E42]">UID: {id ?? ''}</label>
          <br />
          <label className="tw-text-sm tw-text-[#091E42]">MID: {model_id ?? ''}</label>
        </div>
      </div>
      <div className="tw-w-full tw-rounded tw-border-t-2">

        <div style={{ maxHeight: '690px', overflowY: 'auto' }} className="tw-p-3 tw-w-[95%]">
          {loading ? (
            <p className="tw-text-gray-500">Loading...</p>
          ) : logs ? (
            logs?.split('\n\n').reverse().map((logItem, index) => (
              <p key={index} className="tw-border-b tw-break-word tw-py-3">{logItem}</p>
            ))
          ) : (
            <label>{NO_LOGS_FOUND}</label>
          )}
        </div>

      </div>
    </div>
  );
};

export default ARSLogs;